export { default } from './AvatarGroup';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/AvatarGroup/index.js
// module id = 370
// module chunks = 0